// extracted by mini-css-extract-plugin
export default {"btn":"UserAuth_btn__RKFbV","icon":"UserAuth_icon__o2RqG","wrapper":"UserAuth_wrapper__+dYSX","logo":"UserAuth_logo__TT91y"};